import React from 'react';
import PropTypes from 'prop-types';

function TabContent({ className, children }) {
  return (
    <div data-tabs-content className={className}>
      {children}
    </div>
  );
}

TabContent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

TabContent.defaultProps = {
  className: 'horizontal-scroll-sm',
};

export default TabContent;
